import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MedalDisplay } from '../components/medalDisplay';
import { GameGuideLink } from './gameGuideLink';
const CONTAINER_CSS = css `
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  margin: 20px 0;
`;
const TitleContainer = styled.h3 `
  margin: 0;
  color: white;
`;
export const GameGuideMedalDescription = ({ title, medalName, description, imageUrl, gameGuideDetailPageType }) => {
    return (_jsxs("div", { css: CONTAINER_CSS, children: [_jsx(MedalDisplay, { medalName: medalName, imageUrl: imageUrl }), _jsxs("div", { children: [_jsx(TitleContainer, { children: gameGuideDetailPageType ? _jsx(GameGuideLink, { page: gameGuideDetailPageType, label: title }) : title }), description] })] }));
};
